import { ErrorCode, insufficientStockDetailsSchema, type StockShortageDto } from '@eombor/contracts';
import { ApiClientError } from '../../../shared/api/client.js';

/**
 * «Qoldiq yetmadi» javobini TANIB OLISH.
 *
 * Holat kodi (400) bo'yicha ajratib bo'lmaydi: satr yo'qligi ham,
 * sabab yozilmagani ham xuddi shu kod bilan keladi. Shuning uchun
 * server alohida `code` beradi va mijoz aynan shunga qaraydi.
 *
 * Tafsilot SXEMA bilan tekshiriladi: u tugmalarni chizadi va miqdorni
 * o'zgartiradi, ya'ni shakli kutilmaganda boshqacha bo'lsa, oyna
 * yolg'on son ko'rsatishi mumkin. `null` — bu boshqa xato, oddiy
 * yo'ldan ketsin.
 */
export const shortagesOfError = (error: unknown): StockShortageDto[] | null => {
  if (!(error instanceof ApiClientError)) return null;
  if (error.code !== ErrorCode.INSUFFICIENT_STOCK) return null;

  const parsed = insufficientStockDetailsSchema.safeParse(error.details);
  if (!parsed.success) return null;
  return parsed.data.shortages;
};

/** Yetmagan miqdor — bildirgi aynan shuncha uchun yoziladi. */
export const missingQtyOf = (row: StockShortageDto): number =>
  Math.round((row.requested - row.free) * 1000) / 1000;

/**
 * Bor qismini yuborish MA'NOLIMI.
 *
 * Kamida bitta satrda bo'sh qoldiq qolgan bo'lishi kerak. Hammasi nol
 * bo'lsa, «yuborish» bo'sh hujjatni yuborishga urinish bo'lardi va
 * server uni `hasLines` sharti bilan baribir rad etardi — tugmani
 * o'chirib qo'yish rostroq.
 *
 * Talabnomada yetarli satrlar ham bo'lishi mumkin; u holda chaqiruvchi
 * `true` uzatadi.
 */
export const canSendFree = (
  shortages: readonly StockShortageDto[],
  hasHealthyLines: boolean,
): boolean => hasHealthyLines || shortages.some((row) => row.free > 0);
